'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { AcessoRestrito } from '@/shared/components/ui';

/** Gate das duas telas da simulação (conversa e assinatura de teste) para quem não é EDITOR. */
export const AcessoRestritoDaSimulacao = () => {
  const $ = _c(5);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = () => router.push("/");
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>Apenas quem é <span className="font-semibold">editor em Negociações</span> testa os agentes.</>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <AcessoRestrito onVoltarParaInicio={t0} descricao={t1} dica={"Pe\xE7a a um administrador do escrit\xF3rio o perfil de editor em Negocia\xE7\xF5es."} />;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};